import DelimitedFlex from 'app/src/kit/DelimitedFlex'
import InteractiveCard from 'app/src/kit/InteractiveCard'
import UpdateInformation, { UpdateInformationProps } from 'app/src/kit/UpdateInformation'
import { memo } from 'react'
import { styled } from 'styled-components'

const FooterContainer = styled(DelimitedFlex)`
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: ${(p) => p.theme.spacings.md}px;
`

type PlotCardFooter = UpdateInformationProps

const DumbPlotCardFooter: FC<PlotCardFooter> = ({
  warningThreshold,
  dangerThreshold,
  timestamp,
  name,
  timezone
}) => {
  return (
    <FooterContainer $isDelimitedOnTop>
      <UpdateInformation
        timezone={timezone}
        timestamp={timestamp}
        warningThreshold={warningThreshold}
        dangerThreshold={dangerThreshold}
        name={name}
      />
    </FooterContainer>
  )
}

export const PlotCardFooter = memo(DumbPlotCardFooter)

export const StyledCard = styled(InteractiveCard)<{ $isSelected: boolean }>`
  height: 100%;
  width: 352px;

  border-width: 1px;
  border-radius: ${(p) => p.theme.radiuses.lg}px;

  ${(p) =>
    p.$isSelected
      ? `
          border-color: ${p.theme.colors.primary[500]};
        `
      : ''}

  padding: 0;
  overflow: hidden;
`
